import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

function ProtectedRoute({
  children,
  allowedRoles = null,
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ padding: 40, color: '#fff' }}>
        Lade Aeonas...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (
    allowedRoles &&
    !allowedRoles.includes(user.role)
  ) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;